window.updatePrices = (includeVAT) => {
  document.querySelectorAll('.vat-price').forEach(el => {
    const exVAT = el.dataset.priceExvat;
    const incVAT = el.dataset.priceIncvat;
    el.textContent = includeVAT ? incVAT : exVAT;
  });
    const vatMessage = includeVAT ? ' inc VAT' : ' ex VAT';
    const vatIncludedMessage = includeVAT ? 'Taxes included. Discounts and shipping calculated at checkout.' : 'Taxes not included. Discounts and shipping calculated at checkout.'
    const vatMessageHolders = document.querySelectorAll('.vat-message');
    const vatIncludedMessageHolders = document.querySelectorAll('.vat-included-message');
    vatMessageHolders.forEach(el => {
        el.innerHTML = vatMessage;
    });
    vatIncludedMessageHolders.forEach(el => {
        el.innerHTML = vatIncludedMessage;
    })
  const dynamicPrice = document.getElementById('button-dynamic-pricing');
  if (dynamicPrice) {
    const exVAT = dynamicPrice.dataset.priceExvat;
    const incVAT = dynamicPrice.dataset.priceIncvat;
    dynamicPrice.textContent = includeVAT ? incVAT : exVAT;
  }

  document.querySelectorAll('.vat-toggle-switch input[type="checkbox"]').forEach(toggle => {
    toggle.checked = includeVAT;
  });
};
window.bindVatToggle = () => {
  const toggles = document.querySelectorAll('.vat-toggle-switch input[type="checkbox"]');
  const handler = (e) => {
    const newState = e.currentTarget.checked;
    sessionStorage.setItem('vatToggle', newState);
    window.updatePrices(newState);

    if (window.latestTotalPrice) window.updateCustomPriceDisplay(window.latestTotalPrice);
    if (typeof window.updateAllCardPrices === 'function') window.updateAllCardPrices();

    // sync other toggles
    toggles.forEach(t => t !== e.currentTarget && (t.checked = newState));
  };

  toggles.forEach(toggle => {
    toggle.removeEventListener('change', handler);
    toggle.addEventListener('change', handler);
  });
};
document.addEventListener('DOMContentLoaded', () => {
  const storedVAT = sessionStorage.getItem('vatToggle') === 'true';
  window.updatePrices(storedVAT);
  window.bindVatToggle();
});
